import React from "react";
import NothingToSeeIcon from "assets/images/svg-icons/nothingToSeeIcon.svg";
import { MuiBox, MuiTypography } from "components/atoms";
import { useTranslation } from "react-i18next";

const NoDataFound = ({
  title = "common.nothingToSeeHere",
  subTitle = "common.thereAreNoResultsOrData",
}) => {
  const { t } = useTranslation();
  return (
    <MuiBox
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        alignItems: "center",
        width: "100%",
        p: "20px",
      }}
    >
      <MuiBox
        sx={{
          width: "56px",
          height: "56px",
          backgroundColor: "background.gray300",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "50%",
        }}
      >
        <MuiBox sx={{ width: "24px", height: "24px" }}>
          <img
            src={NothingToSeeIcon}
            alt=""
            style={{ width: "100%", height: "100%" }}
          />
        </MuiBox>
      </MuiBox>
      <MuiTypography variant="14" fontWeight="500" color="text.darkBlack">
        {t(title)}
      </MuiTypography>
      <MuiTypography
        variant="14"
        fontWeight="400"
        color="text.lightgray"
        sx={{ textAlign: "center", maxWidth: "360px" }}
      >
        {t(subTitle)}
        {/* There are no results or data to be displayed here. Please choose an
        action below to continue. */}
      </MuiTypography>
    </MuiBox>
  );
};

export default NoDataFound;
